/**
 * @file LanguageSelection.jsx
 * @author Archana
 * @date 2024-10-29
 * @description Component of master settings to manage the tab sections.
 */
import React from "react";
import { Box, Button, Skeleton, Stack, Tab } from "@mui/material";

import { TabList } from "./Tabs";
import { LifecycleSelection } from "./LyfecycleSelection";
import { Interview } from "./Interview";
import { PaymentCyclePopup } from "./PaymentCyclePopup";
import { VFSSchedule } from "./VFSSchedule";
// import { LanguageSelection } from "./LanguageSelection";
// import { DocumentSelection } from "./DocumentSelection";
// import { InstallmentSelection } from "./InstallmentSelection";

export const TabPanel = ({
  isLoading,
  value,
  handleChange,
  lifecycleEvents,
  handleLifecycleChange,
  handleLifecycleSave,
  selectedEvent,
  lead,
  handlePaymentPopup,
  handleClosePopup,
  isPaymentPopupOpen,
  installments,
  submitPayment,
  getCandidateLifecyclEevents,
  countryname,
  coursename,
}) => {
  return (
    <Box
      flex={1}
      borderRadius="12px"
      pb={3}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
      marginLeft={1}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="flex-start"
        mt={2}
      >
        {isLoading ? (
          <Skeleton variant="rounded" sx={{ mt: 1 }} width={380} height={46} />
        ) : (
          <TabList value={value} onChange={handleChange}>
            <Tab label="Event" value={0} />
            <Tab label="Interview" value={1} />
            <Tab label="VFS" value={2} />
          </TabList>
        )}
        {isLoading ? (
          <Skeleton variant="rounded" sx={{ mt: 1 }} width={200} height={46} />
        ) : (
          <Stack display="flex" spacing={1} direction="row" pb={1}>
            <Button
              variant="outlined"
              onClick={handlePaymentPopup}
              sx={{
                width: "200px",
                padding: "8px",
                gap: "8px",
                borderRadius: "12px",
                border: "1px solid var(--Bg-Bg-orange, #E1752D)",
                backgroundColor: "white",
                color: "var(--Text-Tonal-Orange, #FA8232)",
                fontSize: "var(--TypeStyle-H6, 14px)",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "var(--TypeHeight-H6, 29px)", // or simply '29px'
              }}
            >
              Payments
            </Button>
          </Stack>
        )}
      </Stack>
      <PaymentCyclePopup
        open={isPaymentPopupOpen}
        onClose={handleClosePopup}
        installments={installments}
        submitPayment={submitPayment}
        countryname={countryname}
        coursename={coursename}
      />
      <Stack
        flex={1}
        overflow="hidden"
        rowGap={1}
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        {value === 0 ? (
          <LifecycleSelection
            isLoading={isLoading}
            lifecycleEvents={lifecycleEvents}
            handleLifecycleChange={handleLifecycleChange}
            handleLifecycleSave={handleLifecycleSave}
            selectedEvent={selectedEvent}
          />
        ) : null}
        {value === 1 ? (
          <Interview
            isLoading={isLoading}
            lead={lead}
            getCandidateLifecyclEevents={getCandidateLifecyclEevents}
          />
        ) : null}
        {value === 2 ? (
          <VFSSchedule
            isLoading={isLoading}
            lead={lead}
            getCandidateLifecyclEevents={getCandidateLifecyclEevents}
          />
        ) : null}
      </Stack>
    </Box>
  );
};
